var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "18px",
    viewBox: "0 0 27 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sort_by") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.5 L8.75,17.5 L8.75,14.5833333 L0,14.5833333 L0,17.5 Z M0,0 L0,2.91666667 L26.25,2.91666667 L26.25,0 L0,0 Z M0,10.2083333 L17.5,10.2083333 L17.5,7.29166667 L0,7.29166667 L0,10.2083333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instrument-Tracking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-(Grid)",
    transform: "translate(-2233.000000, -370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sort-By",
    transform: "translate(2223.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/content/sort_24px",
    transform: "translate(10.375000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-2)",
    fill: "#00A0E9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.708333, -8.750000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.6666667,
    height: 29.3333333
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/sort_by.1d48ca87afb17df16222eae1cf036d36.svg";
export { ForwardRef as ReactComponent };